import {
  fetchListing,
  USER_ROLES,
} from '@/api/user';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch (context, query = null) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchListing(state.pagination.page, USER_ROLES.ADMIN, query)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        if (res.items && res.pagination) {
          commit('setResponse', res);
        }
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve administrators',
          () => commit('reset')
        )
      )
    ;
  },
};
